module.exports = __webpack_public_path__ + "img/woman-in-kitchen-810x456.1eac6590.jpg";